<template>
  <div>
    <v-card class="form">
      <v-row>
        <v-col cols="12">
          درخواست
          <b>
            {{ fullName }}
          </b>
          <br />
          جهت تدريس در دوره:
          <b>
            {{ doreh.FName }}
          </b>
          <br />
          براي مدرسه (هاي):
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <ol>
            <li v-for="school in schools" :key="school.FSerial">
              {{ school.FName }}
            </li>
          </ol>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>توضیحات:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-textarea outlined v-model="comment" no-resize></v-textarea>
        </v-col>
      </v-row>
    </v-card>
    <app-actions
      @nextStep="nextStep"
      :showCancel="true"
      :lastStep="true"
      @prevStep="prevStep"
    ></app-actions>
  </div>
</template>

<script>
import Actions from "./Actions";
import { getFullName } from "@/utils/auth";
export default {
  components: {
    appActions: Actions,
  },
  computed: {
    fullName() {
      return getFullName();
    },
  },
  data() {
    return {
      comment: "",
    };
  },
  props: ["doreh", "schools"],
  methods: {
    nextStep() {
      this.$emit("nextStep", this.comment);
    },
    prevStep() {
      this.$emit("prevStep");
    },
  },
};
</script>
<style scoped>
ol {
  padding-right: 36px;
}




@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
</style>
